import Vue from 'vue'
import objectToFormData from 'object-to-formdata'

const initialState = {
  list: [],
  contractor: {},
  loading: false
}

export default {
  namespaced: true,
  state: {
    ...initialState
  },
  mutations: {
    SET(state, data) {
      state[data.key] = data.val
    },
    CLEAR(state, key = false) {
      if (key)
        state[key] = initialState[key]
      else state = {...initialState}
    }
  },
  actions: {
    getList({commit}, {params, projectId}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`project_control/projects/${projectId}/contractors/`, {params}).then(response => {
          commit('SET', {key: 'list', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    getContractor({commit}, {projectId, contractorId}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`project_control/projects/${projectId}/contractors/${contractorId}/`).then(response => {
          commit('SET', {key: 'contractor', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    create({commit}, {contractor, projectId}) {
      let data = objectToFormData(contractor)
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.post(`project_control/projects/${projectId}/contractors/`, data, {
          headers: {'Content-Type': 'multipart/form-data'}
        }).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    update({commit}, {projectId, contractor}) {
      if (!contractor.contract_file) {
        delete contractor.contract_file
      }
      let data = objectToFormData(contractor)
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.patch(`project_control/projects/${projectId}/contractors/${contractor.id}/`, data, {
          headers: {'Content-Type': 'multipart/form-data'}
        }).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    remove({commit}, {projectId, contractorId}) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.delete(`project_control/projects/${projectId}/contractors/${contractorId}/`).then(() => {
          resolve()
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    }
  }
}
